import { useApolloClient } from "@vue/apollo-composable"
import createBillingInfoMutation from '@/graphql/billing-info/mutations/createBillingInfo.mutation.gql';
import updateBillingInfoMutation from '@/graphql/billing-info/mutations/updateBillingInfo.mutation.gql';
import billingInfoQuery from "@/graphql/billing-info/queries/billingInfo.query.gql";
export default function useBillingDataGraphql() {
  const {resolveClient} = useApolloClient();
  const apollo = resolveClient('default');
  const createBillingInfo = (billingInfoData) => {
    return apollo.mutate({
      mutation: createBillingInfoMutation,
      variables: {
        billingInfoData
      },
      update(cache, { data }) {
        return cache.updateQuery({
          query: billingInfoQuery,
        }, () => data)
      }
    })
  }

  const updateBillingInfo = (billingInfoData) => {
    return apollo.mutate({
      mutation: updateBillingInfoMutation,
      variables: {
        billingInfoData
      },
      update(cache, { data }) {
        return cache.updateQuery({
          query: billingInfoQuery,
        }, () => data)
      }
    })
  }
  return {
    createBillingInfo,
    updateBillingInfo
  }
}